export type T = Scope

// A map localizable set of devices and properties acting as a navigation context for reCAP
type Scope = {
  id: string
  name: string
  fullName: string
  code: string
  location: GlobalCoordinates
  ianaTimeZone: string
  allowedActions: UserAction[]
}

type GlobalCoordinates = {
  latitude: number // -90 to 90
  longitude: number // -180 to 180
}

type UserAction = typeof USER_ACTIONS[number]

const USER_ACTIONS = [
  'View' as const,
  'HandleCurrentReading' as const,
  'AmendReadingsHistory' as const,
  'RequestSeriesOperationalStatusExport' as const,
  'RequestCustomExport' as const,
  'RequestMonthlyMeterDataExport' as const,
  'AccessRemoteApps' as const,
]

export const from: (input: {
  id: string
  name: string
  fullName: string
  code: string
  location: GlobalCoordinates
  ianaTimeZone: string
  allowedActions: string[]
}) => Scope
  = ({ id, name, fullName, code, location, ianaTimeZone, allowedActions }) => ({
    id,
    name,
    fullName,
    code,
    location,
    ianaTimeZone,
    allowedActions: allowedActions.filter(isUserAction)
  })

export const idOf: (scope: Scope) => string
  = ({ id }) => id
export const displayNameOf: (scope: Scope) => string
  = ({ fullName }) => fullName
export const ianaTimeZoneOf: (scope: Scope) => string
  = ({ ianaTimeZone }) => ianaTimeZone
export const isViewAllowed: (scope: Scope) => boolean
  = ({ allowedActions }) => allowedActions.includes('View')
export const isHandleCurrentReadingAllowed: (scope: Scope) => boolean
  = ({ allowedActions }) => allowedActions.includes('HandleCurrentReading')
export const isAmendReadingsHistoryAllowed: (scope: Scope) => boolean
  = ({ allowedActions }) => allowedActions.includes('AmendReadingsHistory')
export const isAccessRemoteAppsAllowed: (scope: Scope) => boolean
  = ({ allowedActions }) => allowedActions.includes('AccessRemoteApps')

const isUserAction: (candidate: string) => candidate is UserAction
  = (candidate): candidate is UserAction => (USER_ACTIONS as string[]).includes(candidate)